// @ts-nocheck
import {useMemo, useState} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {usersColumns} from './columns/_columns'
import {User} from '../core/_models'
import {KTCardBody} from '../../../../../_metronic/helpers'
import {CustomRow} from './columns/CustomRow'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {UsersListPagination} from '../components/pagination/UsersListPagination'
import {CLIENT_ACCOUNT_TYPE} from '../../../../../constant'

type SearchProps = {
  userSearch: String
  setUserSearch: Function
}
export let AllUsersData
let searchUsers = []

const clean = (text) => text.replace(/[^a-zA-Z0-9 ]/g, '')

const UsersTable = ({
  sDate,
  eDate,
  genderFilter,
  setGenderFilter,
  userSearch,
  setUserSearch,
  page,
  setPage,
}: SearchProps) => {
  let gender = genderFilter
  const [loadingTrue, setLoadingTrue] = useState<boolean>(false)
  const startDate = sDate == '' ? '' : new Date(sDate).toLocaleString()
  const endDate = eDate == '' ? '' : new Date(eDate).toLocaleString()
  let paginationDetails = {}


  AllUsersData = usersData?.getAllUsers?.docs || []

  const getSearchUsers = (filterkeyword) => {
    const pattern = new RegExp('\\b' + clean(filterkeyword), 'i')
    return AllUsersData.filter((x) => pattern.test(clean(x.first_name)))
  }

  searchUsers = getSearchUsers(userSearch)

  if (searchUsers.length > 0 || userSearch) {
    AllUsersData = searchUsers
  }

  const data = useMemo(() => AllUsersData, [AllUsersData])
  const columns = useMemo(() => usersColumns, [])

  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  // const {selected} = useListView()
  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<User>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<User>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <UsersListPagination
        page={page}
        setPage={setPage}
        totalPages={paginationDetails ? paginationDetails?.totalPages : 5}
        loading={loading}
        paginationDetails={paginationDetails}
      />
      {loading && <UsersListLoading />}
      {/* {isFetching && <UsersListLoading />} */}
    </KTCardBody>
  )
}

export {UsersTable}
